import Link from 'next/link';
import { useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

import theme from '../assets/theme';
import { Button } from '../components/_atoms/Button';
import BaseModal from '../components/_molecules/BaseModal';
import { LicenseStates } from '../utils/tenantPlanUtils';
import { TenantLicense } from '../utils/tenantPlanUtils';

const fillAnimation = keyframes`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;

interface FillingRectangleProps {
  duration: number;
}

const FillingRectangle = styled.div<FillingRectangleProps>`
  height: 4px;
  background-color: ${theme.colors.orange};
  animation: ${fillAnimation} ${({ duration }) => `${duration}s`} linear forwards;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

interface MyComponentProps {
  tenantPlan?: TenantLicense;
  duration: number;
}

const TrialWelcomeMessagePopup: React.FC<MyComponentProps> = ({
  tenantPlan,
  duration,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const handleContinue = () => {
    localStorage.setItem('trialWelcomeMessageShown', 'true');
    setIsModalVisible(false);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      handleContinue();
    }, duration * 1000);

    return () => clearTimeout(timer);
  }, [tenantPlan, duration]);

  return (
    <BaseModal
      title={undefined}
      visible={isModalVisible}
      maskClosable={true}
      width="600px"
      style={{
        top: '20px',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        paddingBottom: '0px',
        borderRadius: '10px',
        position: 'relative',
        overflow: 'hidden',
      }}
      maskStyle={{ backgroundColor: 'transparent' }}
    >
      <FillingRectangle duration={duration} />
      You&apos;ve unlocked full access to the <strong>Curipod School Plan</strong>! 🎉 You
      have until{' '}
      <strong>
        {new Intl.DateTimeFormat('en-US', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        }).format(new Date(tenantPlan?.trialExpirationDate ?? 0))}
      </strong>{' '}
      to enjoy all of our premium features.{' '}
      <Link href="/school-plan-trial" passHref>
        <a onClick={() => handleContinue()}>
          <u>Learn more →</u>
        </a>
      </Link>
    </BaseModal>
  );
};

export default TrialWelcomeMessagePopup;
